module.exports = __webpack_public_path__ + "img-lifecycle.ca16c2d6abaf514a9ed89b5005c6a0b0.hashedasset.svg";